import React, { useEffect } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";

import { ForgetPassword, LoginPage } from "../page/Login";

import {
  ERROR_404_PAGE,
  NAVIGATE_TO_ACCOUNTSPAGE,
  NAVIGATE_TO_ACCOUNTVIEWPAGE,
  NAVIGATE_TO_AGENTBANKDETAILSPAGE,
  NAVIGATE_TO_AGENTCOMMISSIONSPAGE,
  NAVIGATE_TO_AGENTSPAGE,
  NAVIGATE_TO_AGENTSTAFFPAGE,
  NAVIGATE_TO_AGENTSTAFFVIEWPAGE,
  NAVIGATE_TO_AGENTVIEWPAGE,
  NAVIGATE_TO_APIACCESSPAGE,
  NAVIGATE_TO_APIACCESSVIEWPAGE,
  NAVIGATE_TO_APIUSAGEPAGE,
  NAVIGATE_TO_DASHBOARD,
  NAVIGATE_TO_FORGETPASSWORD,
  NAVIGATE_TO_INFOPAGE,
  NAVIGATE_TO_LIST_FOLDER_LOGS,
  NAVIGATE_TO_LIST_LOGS,
  NAVIGATE_TO_LOGINPAGE,
  NAVIGATE_TO_LOGSPAGE,
  NAVIGATE_TO_MERCHANTSPAGE,
  NAVIGATE_TO_MERCHANTTRANSACTIONDETAILSPAGE,
  NAVIGATE_TO_MERCHANTTRANSACTIONSPAGE,
  NAVIGATE_TO_MERCHANTVIEWPAGE,
  NAVIGATE_TO_MERCHANTPROPERTIESPAGE,
  NAVIGATE_TO_NOTIFICATIONPAGE,
  NAVIGATE_TO_PARTNERAGENTS,
  NAVIGATE_TO_PARTNERPROPERTIESPAGE,
  NAVIGATE_TO_PARTNERSPAGE,
  NAVIGATE_TO_PARTNERVIEWPAGE,
  NAVIGATE_TO_PROFILEPAGE,
  NAVIGATE_TO_STAFFPAGE,
  NAVIGATE_TO_STAFFVIEWPAGE,
  NAVIGATE_TO_TARRIFPAGE,
  NAVIGATE_TO_TRANSACTIONDETAILSPAGE,
  NAVIGATE_TO_TRANSACTIONPAGE,
  NAVIGATE_TO_VIEWLOGGEDINAPIDETAILSPAGE,
} from "../route/types";
import { STATUS } from "../constant";
import Error404Page from "../page/ErrorsPages/404Error";
import { Main } from "../components";
import {
  AccountViewPage,
  AccountsPage,
  AgentCommissionsPage,
  AgentPage,
  AgentStaffPage,
  AgentStaffViewPage,
  AgentViewPage,
  ApiAccessPage,
  ApiUsagePage,
  Dashboard,
  InfoPage,
  ListLogs,
  LogsPage,
  MerchantTransactionDetailsPage,
  MerchantTransactionsPage,
  MerchantViewPage,
  MerchantsPage,
  MerchantPropertiesPage,
  NotificationPage,
  PartnerViewPage,
  PartnersPage,
  ProfilePage,
  StaffPage,
  StaffViewPage,
  TarrifPage,
  TransactionDetailsPage,
  TransactionPage,
} from "../page";
import ListFolderLogs from "../page/logs/pages/ListFolderLogs";
import ViewApiDetails from "../page/Intergration/pages/ViewApiDetails";
import PartnerPropertiesPage from "../page/Intergration/pages/PartnerPropertiesPage";
import ViewLoggedInApiDetails from "../page/Intergration/pages/ViewLoggedInApiDetails";
import AccountCard from "../page/AgentStaff/pages/AccountCard";
import PartnerAgents from "../page/Partners/pages/PartnerAgents";

// FUNCTION TO DIRECT ONLY AUTH USER TO THEIR PAGES
const ProtectRoute = ({ status }) => {
  return status == STATUS.SUCCESS ? (
    <Outlet />
  ) : (
    <Navigate to={NAVIGATE_TO_LOGINPAGE} />
  );
};

// MAIN FUNC TO RENDER ROUTES AND PAGES
const RoutesContainer = ({ loginStatus }) => {
  const location = useLocation();

  return (
    <Routes key={location.pathname} location={location}>
      <Route path={NAVIGATE_TO_LOGINPAGE} element={<LoginPage />} />

      <Route path={NAVIGATE_TO_FORGETPASSWORD} element={<ForgetPassword />} />

      <Route path="/" element={<ProtectRoute status={loginStatus} />}>
        <Route path="/" element={<Main />}>
          <Route index element={<Dashboard />} />
          <Route path={NAVIGATE_TO_PROFILEPAGE} element={<ProfilePage />} />

          <Route path={NAVIGATE_TO_STAFFPAGE} element={<StaffPage />} />
          <Route path={NAVIGATE_TO_STAFFVIEWPAGE} element={<StaffViewPage />} />

          <Route path={NAVIGATE_TO_AGENTSPAGE} element={<AgentPage />} />
          <Route path={NAVIGATE_TO_AGENTVIEWPAGE} element={<AgentViewPage />} />
          <Route
            path={NAVIGATE_TO_AGENTCOMMISSIONSPAGE}
            element={<AgentCommissionsPage />}
          />
          <Route
            path={NAVIGATE_TO_AGENTBANKDETAILSPAGE}
            element={<AccountCard />}
          />
          <Route
            path={NAVIGATE_TO_AGENTSTAFFPAGE}
            element={<AgentStaffPage />}
          />
          <Route
            path={NAVIGATE_TO_AGENTSTAFFVIEWPAGE}
            element={<AgentStaffViewPage />}
          />

          <Route path={NAVIGATE_TO_PARTNERSPAGE} element={<PartnersPage />} />
          <Route
            path={NAVIGATE_TO_PARTNERVIEWPAGE}
            element={<PartnerViewPage />}
          />
          <Route path={NAVIGATE_TO_PARTNERAGENTS} element={<PartnerAgents />} />

          <Route path={NAVIGATE_TO_MERCHANTSPAGE} element={<MerchantsPage />} />
          <Route
            path={NAVIGATE_TO_MERCHANTVIEWPAGE}
            element={<MerchantViewPage />}
          />
          <Route
            path={NAVIGATE_TO_MERCHANTTRANSACTIONSPAGE}
            element={<MerchantTransactionsPage />}
          />
          <Route
            path={NAVIGATE_TO_MERCHANTTRANSACTIONDETAILSPAGE}
            element={<MerchantTransactionDetailsPage />}
          />
          <Route
            path={NAVIGATE_TO_MERCHANTPROPERTIESPAGE}
            element={<MerchantPropertiesPage />}
          />

          <Route
            path={NAVIGATE_TO_TRANSACTIONPAGE}
            element={<TransactionPage />}
          />
          <Route
            path={NAVIGATE_TO_TRANSACTIONDETAILSPAGE}
            element={<TransactionDetailsPage />}
          />

          <Route path={NAVIGATE_TO_TARRIFPAGE} element={<TarrifPage />} />

          <Route path={NAVIGATE_TO_ACCOUNTSPAGE} element={<AccountsPage />} />
          <Route
            path={NAVIGATE_TO_ACCOUNTVIEWPAGE}
            element={<AccountViewPage />}
          />

          <Route path={NAVIGATE_TO_APIACCESSPAGE} element={<ApiAccessPage />} />
          <Route
            path={NAVIGATE_TO_PARTNERPROPERTIESPAGE}
            element={<PartnerPropertiesPage />}
          />
          <Route path={NAVIGATE_TO_APIUSAGEPAGE} element={<ApiUsagePage />} />
          <Route path={NAVIGATE_TO_LOGSPAGE} element={<LogsPage />} />
          <Route
            path={NAVIGATE_TO_APIACCESSVIEWPAGE}
            element={<ViewApiDetails />}
          />
          <Route
            path={NAVIGATE_TO_VIEWLOGGEDINAPIDETAILSPAGE}
            element={<ViewLoggedInApiDetails />}
          />

          <Route path={NAVIGATE_TO_INFOPAGE} element={<InfoPage />} />
          <Route
            path={NAVIGATE_TO_NOTIFICATIONPAGE}
            element={<NotificationPage />}
          />

          <Route path={NAVIGATE_TO_LIST_LOGS} element={<ListLogs />} />
          <Route
            path={NAVIGATE_TO_LIST_FOLDER_LOGS}
            element={<ListFolderLogs />}
          />
        </Route>
      </Route>

      <Route path={ERROR_404_PAGE} element={<Error404Page />} />
    </Routes>
  );
};

export default RoutesContainer;
